module.exports = __webpack_public_path__ + "static/media/parsing-img.c96dcfcd.png";